export default function submenu() {
  $('[data-dropdown]').click(function (e) {
    e.preventDefault();
    const header = $('#header');
    const active = 'active';
    let dropdown = $(this);
    let val = $(this).data('dropdown');
    let menu = $('[data-menu="' + val + '"]');
    let speed = '400';

    header.removeClass(active);
    if (menu.is(':visible')) {
      menu.fadeOut(speed);
    } else {
      $('[data-dropdown]').removeClass(active);
      $('[data-menu]').fadeOut(speed);
      menu.fadeIn(speed);
      if (dropdown.parent().hasClass('nav-item--product')) {
        header.addClass(active);
      }
    }
  });
}